function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.108 1.607a1 1 0 0 1 1.414 0l.707.708a1 1 0 0 1 0 1.414l-7.822 7.823a.2.2 0 0 1-.12.057l-2.063.225a.2.2 0 0 1-.22-.22l.224-2.064a.2.2 0 0 1 .057-.12l7.823-7.822z",
  fill: "#1063CD"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.623 13.9h-12v-1h12v1z",
  fill: "#1063CD"
});

const SvgPencil = props => React.createElement("svg", _extends({
  width: 13,
  height: 14,
  fill: "none"
}, props), _ref, _ref2);

export default SvgPencil;